import { render, staticRenderFns } from "./merchant-account-contact-form.vue?vue&type=template&id=1da54de0&scoped=true&lang=pug"
import script from "./merchant-account-contact-form.vue?vue&type=script&lang=ts"
export * from "./merchant-account-contact-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da54de0",
  null
  
)

export default component.exports